import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { ROLES } from 'constants/roles';

export const useMutationEditClient = (
  options?: MutationHookOptions<EditClientData, EditClientVariables>,
) => useMutation(EDIT_CLIENT, options);

export const EDIT_CLIENT = gql`
  mutation editClient(
    $id: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $username: String!
    $partner: BusinessPartnerInput
    $salesUser: UserInput
    $shippingAddress: BusinessPartnerShippingAddressInput
    $mainAccount: String
    $downloadFiles: Boolean
    $createOrders: Boolean
    $createReports: Boolean
  ) {
    editClient(
      id: $id
      email: $email
      firstName: $firstName
      lastName: $lastName
      username: $username
      partner: $partner
      salesUser: $salesUser
      shippingAddress: $shippingAddress
      mainAccount: $mainAccount
      downloadFiles: $downloadFiles
      createOrders: $createOrders
      createReports: $createReports
    ) {
      id
      roles
    }
  }
`;

export type MainAccount = 'Main account' | 'Subaccount' | undefined;

export type EditClientVariables = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  username: string;
  partner: { id: number } | undefined;
  salesUser: { id: number } | undefined;
  shippingAddress: { id: number } | undefined;
  mainAccount: MainAccount;
  downloadFiles: boolean;
  createOrders: boolean;
  createReports: boolean;
};

export type EditClientData = {
  editClient: {
    id: string;
    roles: ROLES[];
  };
};
